import { useEffect } from "react";
import "./FullScreenImageModal.scss";

const FullScreenImageModal = ({ show, image, handleCloseFullScreenModal }) => {
  useEffect(() => {
    if (!show) return;

    const handleEsc = (event) => {
      if (event.key === "Escape") {
        handleCloseFullScreenModal();
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [show, handleCloseFullScreenModal]);

  if (!show || !image) return null;

  return (
    <div
      className="full_screen_image_overlay"
      onClick={handleCloseFullScreenModal}
    >
      <div
        className="full_screen_image_container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="full_screen_image_toolbar">
          <button
            type="button"
            className="full_screen_image_close"
            onClick={handleCloseFullScreenModal}
            aria-label="Close image preview"
          >
            Close
          </button>
        </div>
        <div className="full_screen_image_body">
          <img src={image} alt="doubt-img" />
        </div>
      </div>
    </div>
  );
};

export default FullScreenImageModal;
